import LineArrowRightIcon from 'LuxKit/Icons/line/LineArrowRightIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { PICKER_DATE_FORMAT } from 'constants/dateFormats'
import { FlightsFareTypes } from 'constants/flight'
import type { Moment } from 'moment'
import moment from 'moment'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  checkInDate?: Moment
  checkOutDate?: Moment
  fareType?: string
}

function FormattedFlightSearchDate(props: Props) {
  const { checkInDate, checkOutDate, fareType } = props
  const intl = useIntl()

  const isOneWay = fareType === FlightsFareTypes.ONE_WAY

  const formattedCheckInDate = useMemo(() => {
    return checkInDate?.isValid() ? moment(checkInDate).format(PICKER_DATE_FORMAT) : undefined
  }, [checkInDate])

  const formattedCheckOutDate = useMemo(() => {
    return checkOutDate?.isValid() ? moment(checkOutDate).format(PICKER_DATE_FORMAT) : undefined
  }, [checkOutDate])

  const selectDateText = intl.formatMessage({
    id: '1uBg7WuJkh6t4t7RVoK2',
    defaultMessage: 'Select date',
    description: 'Placeholder text for date selection in flight search',
  })

  return <Group direction="horizontal" gap={12} verticalAlign="center">
    <BodyText
      variant="medium"
      weight={formattedCheckInDate ? 'bold' : 'normal'}
      colour={formattedCheckInDate ? 'neutral-one' : 'neutral-three'}
    >
      {formattedCheckInDate || selectDateText}
    </BodyText>

    {!isOneWay && (<>
      <LineArrowRightIcon />

      <BodyText
        variant="medium"
        weight={formattedCheckOutDate ? 'bold' : 'normal'}
        colour={formattedCheckOutDate ? 'neutral-one' : 'neutral-three'}
      >
        {formattedCheckOutDate || selectDateText}
      </BodyText>
    </>)}
  </Group>
}

export default FormattedFlightSearchDate
